module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_18.3aaa81dd.pdf";